import React from "react";
import Navbar from "./Navbar";

const NavigationBar = ({
  open,
  setOpen,
  generalNavItems,
  showMinimizeButton,
  hyroNavItems,
  useCurrentPage,
  showAssistantSelector = true,
  secondaryNavTitle = "Hyro Tools"
}) => (
  <Navbar
    coreNavItems={generalNavItems}
    secondaryNavItems={hyroNavItems}
    secondaryNavTitle={secondaryNavTitle}
    showAssistantSelector={showAssistantSelector}
    useCurrentPage={useCurrentPage}
    open={open}
    setOpen={setOpen}
    showMinimizeButton={showMinimizeButton}
  />
);

export default NavigationBar;
